import PropTypes from "prop-types";
import { InputNumber } from "antd";

const SetCarCapacity = ({ seats, setSeats, bags, setBags, t }) => (
    <div>
        <p className="text-md font-medium mb-4">{t("seatsCount")}</p>
        <div className="flex w-full gap-4">
            <div className="w-1/2">
                <p className="text-sm font-medium mb-2">{t("seats")}</p>
                <InputNumber
                    className="w-full"
                    min={1}
                    value={seats}
                    placeholder={t("rates.seatsPlaceholder")}
                    onChange={setSeats}
                />
            </div>
            <div className="w-1/2">
                <p className="text-sm font-medium mb-2">{t("bags")}</p>
                <InputNumber
                    className="w-full"
                    min={0}
                    value={bags}
                    placeholder={t("rates.bagsPlaceholder")}
                    onChange={setBags}
                />
            </div>
        </div>
    </div>
);

SetCarCapacity.propTypes = {
    seats: PropTypes.number,
    setSeats: PropTypes.func.isRequired,
    bags: PropTypes.number,
    setBags: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
};

export default SetCarCapacity;
